// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6fc64548] .authority-radio label {\n  white-space: pre-line;\n}", ""]);
// Exports
module.exports = exports;
